import * as React from "react"
import {Box, Grid} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";

import PercentageChartNewElement from "./Element";
import PercentageChartNewLabel from "./Label";


export default function PercentageChartNewRowVersion({ data=[], label='', highLevelPercentage=null }) {
	return <Box sx={{ overflowX: 'auto', overflowY: 'hidden' }}>
		<Grid container spacing={2} mt={2}>
			<Grid item xs={1} display="flex" flexDirection="column" justifyContent="center" alignContent="center" pt={0}>
				<Box flexWrap='wrap' fontSize="0.875rem">
					{label}
				</Box>
				{ (highLevelPercentage ?? null) !== null && <Box
					pl={0.5}
					display="flex"
					color="text.disabled"
					fontStyle="italic"
					fontSize="0.833rem"
				>
					({formatPercentage(highLevelPercentage, { decimals: 1 })})
				</Box> }
			</Grid>

			<Grid item xs={11} display="flex" flexDirection="column" width={1} pt={0}>
				<Box display="flex" width={1} height={35} overflow="hidden" textAlign="center">
					{data.map((item, idx) => <PercentageChartNewElement
						key={idx}
						label={item.label}
						width={item.width}
						diff={item.diff}
						color={item.color}
						fontColor={item.fontColor}
						link={item.link}
						remainingData={item.remainingData || []}
					/> )}
				</Box>
				<Box display="flex" width={1} height={30} overflow="hidden" textAlign="center">
					{data.map((item, idx) => <PercentageChartNewLabel
						key={idx}
						width={item.width}
						label={item.label}
					/> )}
				</Box>
			</Grid>
		</Grid>
	</Box>
}